var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useTranslation, currentLanguage } from "../../next-i18next";
import { Routes } from "../../utils/types/routes";
import { LeadProvider } from "../../context/LeadProvider";
import { ProgressProvider } from "../../context/ProgressProvider";
import { ApplicationProvider } from "../../context/ApplicationProvider";
import { FeatureFlagsProvider } from "../../context/FeatureFlagsProvider";
import { useGoogleAnalytics } from "../../context/GoogleAnalyticsProvider";
import { ZendeskProvider } from "../../context/ZendeskProvider";
import { MaintenanceProvider } from "../../context/MaintenanceProvider";
import { useAuth0 } from "@auth0/auth0-react";
export var Auth = function (_a) {
    var children = _a.children, required = _a.required, openAppNotRequired = _a.openAppNotRequired, getLayout = _a.getLayout;
    var t = useTranslation().t;
    var userLanguage = currentLanguage();
    var trackUserAuthentication = useGoogleAnalytics().trackUserAuthentication;
    var router = useRouter();
    var _b = useAuth0(), user = _b.user, isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading, getIdTokenClaims = _b.getIdTokenClaims;
    useEffect(function () {
        var checkAuthAndTrack = function () { return __awaiter(void 0, void 0, void 0, function () {
            var claims, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (user &&
                            isAuthenticated &&
                            user.email_verified === false &&
                            !router.pathname.includes(Routes.SignUpVerifyAccount)) {
                            // We do this instead of a router.push so that
                            // we get a full refresh which will re-instantiate the
                            // state machine and start with the correct initial status
                            if (userLanguage === "en") {
                                window.location.href = Routes.SignUpVerifyAccount;
                            }
                            else {
                                window.location.href = "/".concat(userLanguage, "/").concat(Routes.SignUpVerifyAccount);
                            }
                        }
                        if (!(user && isAuthenticated)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getIdTokenClaims()];
                    case 1:
                        claims = _a.sent();
                        token = claims.__raw;
                        trackUserAuthentication(user.email, token);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        checkAuthAndTrack();
    }, [
        router,
        user === null || user === void 0 ? void 0 : user.email_verified,
        required,
        user,
        isAuthenticated,
        getIdTokenClaims,
        trackUserAuthentication,
    ]);
    if (isLoading) {
        return <div>{t("Loading")}</div>;
    }
    if (user && required) {
        return (<LeadProvider>
        <FeatureFlagsProvider>
          <ZendeskProvider>
            <MaintenanceProvider>
              <ProgressProvider>
                {openAppNotRequired === true ? (children) : (<ApplicationProvider getLayout={getLayout}>
                    {children}
                  </ApplicationProvider>)}
              </ProgressProvider>
            </MaintenanceProvider>
          </ZendeskProvider>
        </FeatureFlagsProvider>
      </LeadProvider>);
    }
    else if (!required) {
        return (<FeatureFlagsProvider>
        <ZendeskProvider>
          <MaintenanceProvider>{children}</MaintenanceProvider>
        </ZendeskProvider>
      </FeatureFlagsProvider>);
    }
    return null;
};
//# sourceMappingURL=data:application/json;base64,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